import { defineElement } from '@umbraco-ui/uui-base/lib/registration';
import { demandCustomElement } from '@umbraco-ui/uui-base/lib/utils';
import { css, html } from 'lit';
import { UUIInputElement } from '@umbraco-ui/uui-input/lib';
import { iconLock, iconUnlock } from '@umbraco-ui/uui-icon-registry-essential/lib/svgs';
import { property } from 'lit/decorators.js';
import { UUIEvent } from '@umbraco-ui/uui-base/lib/events';

class UUIInputLockEvent extends UUIEvent {
  static {
    this.LOCK_CHANGE = "lock-change";
  }
  constructor(evName, eventInit = {}) {
    super(evName, {
      ...{ bubbles: true },
      ...eventInit
    });
  }
}

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), member.set(obj, value), value);
var _locked;
let UUIInputLockElement = class extends UUIInputElement {
  constructor() {
    super();
    __privateAdd(this, _locked, true);
    this.unlockLabel = "Unlock input";
    this.lockLabel = "Lock input";
    this.readonly = true;
    this.tabIndex = -1;
  }
  set locked(lock) {
    __privateSet(this, _locked, lock);
    this.readonly = lock;
    this.tabIndex = lock ? -1 : 0;
  }
  get locked() {
    return __privateGet(this, _locked);
  }
  connectedCallback() {
    super.connectedCallback();
    demandCustomElement(this, "uui-icon");
    demandCustomElement(this, "uui-button");
  }
  _onLockToggle() {
    this.locked = !this.locked;
    this.pristine = false;
    this.dispatchEvent(new UUIInputLockEvent(UUIInputLockEvent.LOCK_CHANGE));
    if (!this.locked) {
      this._input?.focus();
    }
  }
  renderIcon() {
    return this.locked === true ? html`<uui-icon name="lock" .fallback=${iconLock.strings[0]}></uui-icon>` : html`<uui-icon
          name="unlock"
          .fallback=${iconUnlock.strings[0]}></uui-icon>`;
  }
  renderPrepend() {
    return html`<uui-button
      .disabled=${this.disabled}
      @click=${this._onLockToggle}
      compact
      id="lock"
      label="${this.locked ? this.unlockLabel : this.lockLabel}">
      ${this.renderIcon()}
    </uui-button>`;
  }
};
_locked = new WeakMap();
UUIInputLockElement.styles = [
  ...UUIInputElement.styles,
  css`
      #lock {
        height: 100%;

        --uui-input-padding: 1px var(--uui-size-space-1,3px);
        --uui-button-padding-left-factor: 0.75;
        --uui-button-padding-right-factor: 0.75;
        font-size: 12px;
      }

      :host([locked]) #input {
        cursor: not-allowed;
        opacity: 0.55;
      }
    `
];
__decorateClass([
  property({ type: Boolean, reflect: true })
], UUIInputLockElement.prototype, "locked", 1);
__decorateClass([
  property({ type: String, reflect: false, attribute: "unlock-label" })
], UUIInputLockElement.prototype, "unlockLabel", 2);
__decorateClass([
  property({ type: String, reflect: false, attribute: "lock-label" })
], UUIInputLockElement.prototype, "lockLabel", 2);
UUIInputLockElement = __decorateClass([
  defineElement("uui-input-lock")
], UUIInputLockElement);

export { UUIInputLockElement, UUIInputLockEvent };
